import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

import { Button } from "../ui/button";
import { ouvirQuedaDoTempoReal } from "../../services/socket-io";

// Aviso de que o tempo real caiu.
//
// Com a conexão caída a tela não erra nada à vista: ela só para no tempo — e
// tela parada parece tela atualizada. Era a sensação de "perdeu a sincronia"
// sem saber por quê. Quando a conexão volta, o "resync" (ou a recuperação do
// servidor) traz o que passou e o aviso some sozinho.

// No computador fica embaixo à esquerda, sobre o fim do menu: no alto cobria
// o nome do contato no cabeçalho da conversa, e à direita disputa lugar com o
// aviso de versão nova. No celular, no alto — embaixo é a barra de navegação.

// Queda curta (troca de wi-fi, deploy) se resolve antes de alguém ler.
const ESPERA_PARA_MOSTRAR_MS = 5000;

const AvisoDeTempoReal = () => {
	const [mostrar, setMostrar] = useState(false);

	useEffect(() => {
		let timer = null;

		const parar = ouvirQuedaDoTempoReal((caido) => {
			clearTimeout(timer);

			if (caido) {
				timer = setTimeout(() => setMostrar(true), ESPERA_PARA_MOSTRAR_MS);
			} else {
				setMostrar(false);
			}
		});

		return () => {
			clearTimeout(timer);
			parar();
		};
	}, []);

	if (!mostrar) return null;

	const semInternet = typeof navigator !== "undefined" && !navigator.onLine;

	return (
		<div
			role="status"
			className="fixed inset-x-3 top-[calc(0.75rem+env(safe-area-inset-top))] z-50 flex items-center gap-3 rounded-xl border border-amber-500/40 bg-card p-3 shadow-lg md:inset-x-auto md:top-auto md:bottom-4 md:left-4 md:max-w-sm"
		>
			<WifiOff className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
			<div className="min-w-0 flex-1">
				<p className="text-sm font-medium">
					{semInternet ? "Sem internet" : "Reconectando…"}
				</p>
				<p className="text-xs text-muted-foreground">
					Mensagens novas aparecem assim que a conexão voltar.
				</p>
			</div>
			<Button
				size="sm"
				variant="outline"
				className="h-8 shrink-0"
				onClick={() => window.location.reload()}
			>
				Recarregar
			</Button>
		</div>
	);
};

export default AvisoDeTempoReal;
